import { render, staticRenderFns } from "./charPietDataSex.vue?vue&type=template&id=70965cd2&scoped=true&"
import script from "./charPietDataSex.vue?vue&type=script&lang=js&"
export * from "./charPietDataSex.vue?vue&type=script&lang=js&"
import style0 from "./charPietDataSex.vue?vue&type=style&index=0&id=70965cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70965cd2",
  null
  
)

export default component.exports